/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_AriaInputs */

const en_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy ID`)
};

const fr_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l'ID`)
};

const de_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier-ID`)
};

const it_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia ID`)
};

const ru_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копия удостоверения личности`)
};

const es_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar identificación`)
};

const zh_cn2_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份证复印件`)
};

const ja_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDをコピー`)
};

const hi_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आईडी की प्रतिलिपि बनाएं`)
};

const pt_pt2_explorer_info_copy_id_aria = /** @type {(inputs: Explorer_Info_Copy_Id_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar documento de identidade`)
};

/**
* | output |
* | --- |
* | "Copy ID" |
*
* @param {Explorer_Info_Copy_Id_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_aria = /** @type {((inputs?: Explorer_Info_Copy_Id_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_copy_id_aria(inputs)
	if (locale === "de") return de_explorer_info_copy_id_aria(inputs)
	if (locale === "it") return it_explorer_info_copy_id_aria(inputs)
	if (locale === "ru") return ru_explorer_info_copy_id_aria(inputs)
	if (locale === "es") return es_explorer_info_copy_id_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_copy_id_aria(inputs)
	if (locale === "ja") return ja_explorer_info_copy_id_aria(inputs)
	if (locale === "hi") return hi_explorer_info_copy_id_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_copy_id_aria(inputs)
	return en_explorer_info_copy_id_aria(inputs)
});